module.exports = __webpack_public_path__ + "img/unauthorized.92ec7887.png";